import { overrideForm } from '@form/overrideForm';
import { insertForm } from '@form/insertForm';
import config from '@config';
import i18n from '@i18n';
import state from '@state';
import { log } from '@utils/logger';
import { v4 as uuidv4 } from 'uuid';
import { isInVariant } from '@utils/aBTesting'; // Import the A/B testing function
import { restoreAexResponse } from '@utils/sessionStorage';

export function overrideSearchForms(): void {
	config.instances.forEach((instance) => {
		// Conditional validation based on the mode
		if (instance.mode === 'override') {
			if (!instance.searchForm) {
				console.error(i18n.t('error.searchFormValidation', { prefix: i18n.t('log.prefix') }));
				return;
			}
		} else if (instance.mode === 'inject') {
			if (!instance.searchContainer) {
				console.error(i18n.t('error.searchContainerValidation', { prefix: i18n.t('log.prefix') }));
				return;
			}
		}

		// Proceed with the logic for each mode
		if (instance.mode === 'override' && instance.searchForm) {
			const selector = instance.searchContainer
				? `${instance.searchContainer} ${instance.searchForm}`
				: instance.searchForm;
			const elements = document.querySelectorAll<HTMLElement>(selector);

			if (elements.length === 0) {
				console.error(i18n.t('error.noFormsError', { prefix: i18n.t('log.prefix') }));
				document.body.setAttribute('data-aex-no-forms', 'true');
			}

			elements.forEach((element) => {
				if (element.hasAttribute('data-aex-overridden') || element.hasAttribute('data-aex-skipped')) {
					return;
				}

				if (instance.ABTest !== null && instance.ABTest !== undefined && !isInVariant(instance.ABTest)) {
					element.setAttribute('data-aex-skipped', 'true');
					log(i18n.t('log.abTestExcluded', {
						prefix: i18n.t('log.prefix'),
						selector: instance.searchForm,
					}));

					return;
				}

				instance.index = uuidv4(); // Used for unique Ids
				const form = element.closest('form') as HTMLFormElement | null;
				if (form && !form.hasAttribute('data-aex-overridden') && !form.hasAttribute('data-aex-skipped')) {
					overrideForm(form, instance);
					state.overriddenElements.add(form);

					restoreAexResponse(instance);
				}
			});
		} else if (instance.mode === 'inject' && instance.searchContainer) {
			const searchContainer = document.querySelector<HTMLElement>(instance.searchContainer);

			if (searchContainer) {
				if (searchContainer.hasAttribute('data-aex-form') || searchContainer.hasAttribute('data-aex-skipped')) {
					return;
				}

				instance.index = uuidv4(); // Used for unique Ids
				instance.searchForm = '#aex-search-form-' + instance.index; // Used for transcription selectors

				if (searchContainer instanceof HTMLElement) {
					if (instance.ABTest !== null && instance.ABTest !== undefined && !isInVariant(instance.ABTest)) {
						searchContainer.setAttribute('data-aex-skipped', 'true');
						log(i18n.t('log.abTestExcluded',
							{
								selector: instance.index,
								prefix: i18n.t('log.prefix'),
							}));
						return;
					}

					insertForm(searchContainer, instance);

					restoreAexResponse(instance);
				} else {
					log(`${i18n.t('error.invalidSearchContainer', { prefix: i18n.t('log.prefix') })} ${instance.searchContainer}`);
				}
			} else {
				log(`${i18n.t('error.invalidSearchContainer', { prefix: i18n.t('log.prefix') })} ${instance.searchContainer}`);
			}
		}
	});
}

export { overrideForm };
